import { Badge } from '@/shared/components/ui/badge/Badge';
import { TextLink } from '@/shared/components/ui/text-link/TextLink';
import { Tooltip } from '@/shared/components/ui/tooltip/Tooltip';
import { coverageBadgeLabel, missingTypeNames } from '../../utils/coverageSummary';
import type { AssignableDocumentType } from '../../types/documentTemplates.types';

interface Props {
  status: 'loading' | 'error' | 'ready';
  missing: readonly AssignableDocumentType[];
  documentsPath: string;
}

export function DocumentCoverageCell({ status, missing, documentsPath }: Props) {
  if (status === 'loading') {
    return (
      <span className="inline-block h-4 w-20 animate-pulse rounded bg-mp-border align-middle">
        <span className="sr-only">Loading document coverage</span>
      </span>
    );
  }
  if (status === 'error') {
    return <span className="text-sm text-mp-muted">Unavailable</span>;
  }
  if (missing.length === 0) {
    return <Badge variant="success" size="xs">{coverageBadgeLabel(missing)}</Badge>;
  }
  const names = missingTypeNames(missing);
  return (
    <TextLink to={documentsPath} color="neutral" className="block space-y-1 no-underline">
      <Tooltip content={`Missing: ${names}`}>
        <Badge variant="warning" size="xs">{coverageBadgeLabel(missing)}</Badge>
      </Tooltip>
      <span className="block text-xs text-mp-muted sm:hidden">{names}</span>
    </TextLink>
  );
}
